
import { useState, useRef, useEffect, useCallback } from "react";
import { 
  Home, 
  Users, 
  FileText, 
  CreditCard, 
  BarChart2, 
  Settings, 
  ChevronRight, 
  BookOpen,
  ArrowRightLeft,
  ShoppingBag,
  ShoppingCart,
  BarChart,
  Search,
  Heart,
  HelpCircle,
  Files,
  Combine,
  Group,
  FileUp,
  Sheet,
  Truck,
  BadgePercent,
  HandCoins,
  WalletCards,
  CalendarCheck,
  LogOut,
  PiggyBank,
  User,
  X,
  Grid3X3,
  TrendingUp,
  Car,
  DollarSign,
  Shield,
  Calculator,
  Scale
} from 'lucide-react';
import { useNavigate } from "react-router-dom";
import DropDown from '../../pages/DropDown'; 


export default function BottomNavBar({ activeTab, setActiveTab}) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const [active, setActive]   = useState(false);

  const [mobOpen, setMobOpen] = useState(true);
  const navRef                = useRef(null);


/* ─── Inject Quicksand font ─────────────────────────────────────────────────── */
const injectFont = () => {
  if (document.getElementById("qs-font")) return;
  const l = document.createElement("link");
  l.id = "qs-font";
  l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap";
  document.head.appendChild(l);
};

/* ─── Category Data ─────────────────────────────────────────────────────────── */
const MENUS = {
  browse: {
    label: "Browse",
    featured: { label: "Trending Now", tag: "🔥", items: ["New Arrivals", "Under €30", "Sale Items", "Staff Picks", "Sustainable"] },
    sections: [
      {
        title: "Fashion",
        cats: [
          { icon: "👗", name: "Dresses",    count: "2.4k", bg: "#fff1ee" },
          { icon: "👟", name: "Sneakers",   count: "1.8k", bg: "#eff6ff" },
          { icon: "👜", name: "Handbags",   count: "980",  bg: "#fffbeb" },
          { icon: "🧥", name: "Outerwear",  count: "540",  bg: "#f5f3ff" },
        ],
      },
      {
        title: "Tech",
        cats: [
          { icon: "💻", name: "Laptops",    count: "430",  bg: "#ecfdf5" },
          { icon: "📱", name: "Phones",     count: "670",  bg: "#eef2ff" },
          { icon: "🎧", name: "Audio",      count: "320",  bg: "#fdf2f8" },
          { icon: "⌚", name: "Wearables",  count: "280",  bg: "#fff7ed" },
        ],
      },
      {
        title: "Home & More",
        cats: [
          { icon: "🏠", name: "Home",       count: "1.1k", bg: "#f0fdfa" },
          { icon: "🍳", name: "Kitchen",    count: "750",  bg: "#fef2f2" },
          { icon: "⚽", name: "Sports",     count: "900",  bg: "#f0fdf4" },
          { icon: "📚", name: "Books",      count: "2.1k", bg: "#faf5ff" },
        ],
      },
    ],
  },
  women: {
    label: "Women",
    featured: { label: "Women's Picks", tag: "✨", items: ["New In Women", "Occasion Wear", "Sustainable", "Summer Edit"] },
    sections: [
      {
        title: "Clothing",
        cats: [
          { icon: "👗", name: "Dresses",    count: "2.4k", bg: "#fff1ee" },
          { icon: "👚", name: "Tops",       count: "1.6k", bg: "#fdf2f8" },
          { icon: "🩱", name: "Swimwear",   count: "270",  bg: "#eff6ff" },
          { icon: "🧣", name: "Scarves",    count: "340",  bg: "#f5f3ff" },
        ],
      },
      {
        title: "Accessories",
        cats: [
          { icon: "👠", name: "Heels",      count: "890",  bg: "#fffbeb" },
          { icon: "👜", name: "Bags",       count: "980",  bg: "#ecfdf5" },
          { icon: "💍", name: "Jewellery",  count: "540",  bg: "#faf5ff" },
          { icon: "💄", name: "Beauty",     count: "1.2k", bg: "#fef2f2" },
        ],
      },
    ],
  },
  men: {
    label: "Men",
    featured: { label: "Men's Picks", tag: "🎯", items: ["New In Men", "Workwear", "Activewear", "Summer Sale"] },
    sections: [
      {
        title: "Clothing",
        cats: [
          { icon: "👔", name: "Shirts",     count: "1.1k", bg: "#eff6ff" },
          { icon: "🧥", name: "Jackets",    count: "430",  bg: "#eef2ff" },
          { icon: "🩳", name: "Shorts",     count: "610",  bg: "#ecfdf5" },
          { icon: "🧤", name: "Accessories",count: "320",  bg: "#fff7ed" },
        ],
      },
      {
        title: "Shoes & Grooming",
        cats: [
          { icon: "👟", name: "Sneakers",   count: "980",  bg: "#fff1ee" },
          { icon: "🧴", name: "Grooming",   count: "270",  bg: "#f0fdfa" },
          { icon: "⌚", name: "Watches",    count: "320",  bg: "#faf5ff" },
          { icon: "👓", name: "Sunglasses", count: "180",  bg: "#fdf2f8" },
        ],
      },
    ],
  },
};

const SIMPLE_LINKS = ["Sale 🔥", "New In", "Brands"];

/* ─── Styles ────────────────────────────────────────────────────────────────── */
const CSS = `
  .snav-root *{box-sizing:border-box;margin:0;padding:0;}
  .snav-root{font-family:'Quicksand',sans-serif;position:relative;}

  .snav-bar{
    background:#fff;
    border-bottom:1px solid rgba(0,0,0,0.07);
    position:relative;z-index:200;
  }
  .snav-inner{
    max-width:1280px;margin:0 auto;
    display:flex;align-items:center;
    padding:0 28px;height:68px;gap:12px;
  }

  /* Logo */
  .snav-logo{
    font-size:24px;font-weight:700;letter-spacing:-1px;
    color:#1a1a2e;flex-shrink:0;cursor:pointer;
    display:flex;align-items:center;gap:2px;user-select:none;
  }
  .snav-logo-dot{color:#ff5c35;}
  .snav-logo-badge{
    font-size:9px;font-weight:700;
    background:#ff5c35;color:#fff;
    border-radius:5px;padding:2px 6px;
    margin-left:6px;letter-spacing:.8px;
    font-family:'Quicksand',sans-serif;
  }

  /* Nav links */
  .snav-links{
    display:flex;align-items:center;gap:2px;
    list-style:none;flex:1;justify-content:center;
  }
  .snav-link-btn{
    font-family:'Quicksand',sans-serif;
    display:flex;align-items:center;gap:5px;
    padding:8px 16px;border-radius:12px;
    font-size:14px;font-weight:600;
    color:#1a1a2e;background:transparent;
    border:none;cursor:pointer;
    transition:background .16s,color .16s;
    white-space:nowrap;
  }
  .snav-link-btn:hover,.snav-link-btn.active{
    background:#fff1ee;color:#ff5c35;
  }
  .snav-chevron{transition:transform .22s cubic-bezier(.4,0,.2,1);flex-shrink:0;}
  .snav-chevron.open{transform:rotate(180deg);}
  .snav-sale-pill{
    font-size:10px;font-weight:700;
    background:#ff5c35;color:#fff;
    border-radius:5px;padding:2px 6px;
    font-family:'Quicksand',sans-serif;
  }

  /* Actions */
  .snav-actions{display:flex;align-items:center;gap:6px;flex-shrink:0;}
  .snav-icon-btn{
    width:40px;height:40px;border-radius:12px;
    border:1px solid rgba(0,0,0,0.08);
    background:transparent;
    display:flex;align-items:center;justify-content:center;
    cursor:pointer;color:#1a1a2e;position:relative;
    transition:all .16s;
  }
  .snav-icon-btn:hover{background:#fff1ee;border-color:#ff5c35;color:#ff5c35;}
  .snav-badge{
    position:absolute;top:-5px;right:-5px;
    width:18px;height:18px;border-radius:50%;
    background:#ff5c35;color:#fff;
    font-size:10px;font-weight:700;
    display:flex;align-items:center;justify-content:center;
    border:2px solid #fff;font-family:'Quicksand',sans-serif;
  }
  .snav-cta{
    font-family:'Quicksand',sans-serif;
    background:#1a1a2e;color:#fff;
    border:none;padding:10px 22px;border-radius:12px;
    font-size:13px;font-weight:700;cursor:pointer;
    transition:all .18s;white-space:nowrap;
  }
  .snav-cta:hover{background:#ff5c35;transform:translateY(-1px);}

  /* Hamburger */
  .snav-ham{
    display:none;width:40px;height:40px;border-radius:12px;
    border:1px solid rgba(0,0,0,0.08);background:transparent;
    flex-direction:column;align-items:center;justify-content:center;
    gap:5px;cursor:pointer;transition:border-color .16s;
  }
  .snav-ham:hover{border-color:#ff5c35;}
  .snav-ham span{
    width:18px;height:2px;background:#1a1a2e;
    border-radius:2px;transition:all .28s ease;display:block;
  }
  .snav-ham.open span:nth-child(1){transform:rotate(45deg) translate(5px,5px);}
  .snav-ham.open span:nth-child(2){opacity:0;transform:scaleX(0);}
  .snav-ham.open span:nth-child(3){transform:rotate(-45deg) translate(5px,-5px);}

  /* Overlay */
  .snav-overlay{
    position:fixed;inset:0;z-index:150;
    background:rgba(26,26,46,.3);
    backdrop-filter:blur(3px);
    opacity:0;pointer-events:none;
    transition:opacity .25s;
  }
  .snav-overlay.show{opacity:1;pointer-events:all;}

  /* Dropdown */
  .snav-dropdown{
   
    background:#fff;
    border:1px solid rgba(0,0,0,0.07);
   
    box-shadow:0 24px 64px rgba(0,0,0,0.13),0 4px 16px rgba(0,0,0,0.05);
    opacity:0;pointer-events:none;
    transition:opacity .22s cubic-bezier(.4,0,.2,1),transform .22s cubic-bezier(.4,0,.2,1);
   overflow-y:auto;
  }
  .snav-dropdown.open{
    opacity:1;pointer-events:all;
   
  }

  /* Dropdown top bar */
  .snav-drop-head{
    display:flex;align-items:center;justify-content:space-between;
    padding:20px 26px 4px;
  }
  .snav-drop-title{
    font-size:11px;font-weight:700;color:#c0bfc8;
    letter-spacing:1.4px;text-transform:uppercase;
  }
  .snav-drop-viewall{
    font-family:'Quicksand',sans-serif;
    font-size:12px;font-weight:700;color:#ff5c35;
    background:none;border:none;cursor:pointer;
    display:flex;align-items:center;gap:4px;
    padding:5px 10px;border-radius:8px;
    transition:background .14s;
  }
  .snav-drop-viewall:hover{background:#fff1ee;}

  /* Section rows */
  .snav-drop-body{padding:14px 26px 22px;}
  .snav-section{margin-bottom:18px;}
  .snav-section:last-child{margin-bottom:0;}
  .snav-section-label{
    font-size:10px;font-weight:700;color:#d0cfd8;
    letter-spacing:1.2px;text-transform:uppercase;
    margin-bottom:10px;padding-left:2px;
  }
  .snav-cat-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

  /* Category card */
  .snav-cat-card{
    display:flex;flex-direction:column;align-items:left;
    gap:9px;padding:16px 10px;border-radius:16px;
    background:#f9f8f6;
    border:1.5px solid transparent;
    cursor:pointer;transition:all .18s ease;
    text-decoration:none;
  }
  .snav-cat-card:hover{
    background:#fff;
    border-color:rgba(255,92,53,0.25);
    transform:translateY(-3px);
    box-shadow:0 8px 24px rgba(255,92,53,0.12);
  }
  .snav-cat-icon-wrap{
    width:50px;height:50px;border-radius:14px;
    display:flex;align-items:center;justify-content:center;
    font-size:26px;transition:transform .18s;
  }
  .snav-cat-card:hover .snav-cat-icon-wrap{transform:scale(1.1) rotate(-4deg);}
  .snav-cat-name{
    font-size:12px;font-weight:700;color:#1a1a2e;
    text-align:center;line-height:1.2;
  }
  .snav-cat-count{font-size:10px;color:#b0afc0;font-weight:600;}

  /* Featured tag strip */
  .snav-feat-strip{
    border-top:1px solid rgba(0,0,0,0.055);
    background:#fafaf7;
    padding:14px 26px;
    display:flex;align-items:center;gap:7px;flex-wrap:wrap;
  }
  .snav-feat-label{
    font-size:11px;font-weight:700;color:#b0afc0;
    white-space:nowrap;margin-right:2px;
  }
  .snav-feat-tag{
    font-family:'Quicksand',sans-serif;
    display:inline-flex;align-items:center;
    padding:6px 14px;border-radius:20px;
    background:#fff;border:1px solid rgba(0,0,0,0.08);
    font-size:12px;font-weight:600;color:#1a1a2e;
    cursor:pointer;transition:all .15s;white-space:nowrap;
  }
  .snav-feat-tag:hover{
    background:#ff5c35;color:#fff;
    border-color:#ff5c35;transform:translateY(-1px);
    box-shadow:0 4px 12px rgba(255,92,53,0.3);
  }

  /* Desktop search */
  .snav-search-desktop{
    display:flex;align-items:center;
    background:#f8f7f4;border-radius:12px;
    padding:9px 14px;gap:8px;flex:1;max-width:260px;
    border:1.5px solid transparent;transition:all .18s;
  }
  .snav-search-desktop:focus-within{
    border-color:#ff5c35;background:#fff;
    box-shadow:0 0 0 4px rgba(255,92,53,0.08);
  }
  .snav-search-desktop input{
    flex:1;border:none;background:transparent;
    font-family:'Quicksand',sans-serif;font-size:13px;font-weight:500;
    color:#1a1a2e;outline:none;
  }
  .snav-search-desktop input::placeholder{color:#b0afc0;}

  /* Mobile menu */
  .snav-mob{
    position:fixed;top:68px;right:0;bottom:0;
    width:min(360px,100vw);
    background:#fff;z-index:190;
    overflow-y:auto;
    transform:translateX(100%);
    transition:transform .3s cubic-bezier(.4,0,.2,1);
    border-left:1px solid rgba(0,0,0,0.07);
  }
  .snav-mob.open{transform:translateX(0);}
  .snav-mob-inner{padding:20px 16px 40px;}
  .snav-mob-section{margin-bottom:24px;}
  .snav-mob-sec-title{
    font-size:10px;font-weight:700;color:#b0afc0;
    letter-spacing:1.2px;text-transform:uppercase;
    padding-bottom:10px;
    border-bottom:1px solid rgba(0,0,0,0.06);
    margin-bottom:12px;
  }
  .snav-mob-cat-grid{
    display:grid;grid-template-columns:repeat(3,1fr);gap:8px;
  }
  .snav-mob-cat{
    display:flex;flex-direction:column;align-items:center;gap:6px;
    padding:12px 6px;border-radius:14px;background:#f9f8f6;
    border:1.5px solid transparent;cursor:pointer;
    text-decoration:none;transition:all .15s;
  }
  .snav-mob-cat:hover,.snav-mob-cat:active{
    border-color:#ff5c35;background:#fff1ee;
  }
  .snav-mob-cat-icon{font-size:24px;}
  .snav-mob-cat-name{font-size:11px;font-weight:700;color:#1a1a2e;text-align:center;}
  .snav-mob-links-list{display:flex;flex-direction:column;gap:6px;}
  .snav-mob-link{
    display:flex;align-items:center;justify-content:space-between;
    padding:13px 16px;border-radius:14px;
    background:#f9f8f6;font-size:14px;font-weight:700;
    color:#1a1a2e;border:1.5px solid transparent;
    cursor:pointer;transition:all .15s;
    font-family:'Quicksand',sans-serif;width:100%;text-align:left;
  }
  .snav-mob-link:hover{background:#fff1ee;color:#ff5c35;border-color:rgba(255,92,53,0.2);}
  .snav-mob-search{
    display:flex;align-items:center;gap:8px;
    background:#f9f8f6;border-radius:14px;
    padding:11px 14px;margin-bottom:20px;
    border:1.5px solid transparent;transition:all .18s;
  }
  .snav-mob-search:focus-within{border-color:#ff5c35;background:#fff;}
  .snav-mob-search-inp{
    flex:1;border:none;background:transparent;
    font-family:'Quicksand',sans-serif;font-size:14px;font-weight:500;
    color:#1a1a2e;outline:none;
  }
  .snav-mob-search-inp::placeholder{color:#b0afc0;}
  .snav-mob-cta{
    font-family:'Quicksand',sans-serif;
    width:100%;background:#1a1a2e;color:#fff;
    border:none;padding:14px;border-radius:14px;
    font-size:14px;font-weight:700;cursor:pointer;
    margin-top:8px;transition:background .18s;
  }
  .snav-mob-cta:hover{background:#ff5c35;}

  /* Promo banner inside dropdown */
  .snav-promo{
    display:flex;align-items:center;gap:10px;
    background:linear-gradient(135deg,#1a1a2e 0%,#2d2d4e 100%);
    border-radius:14px;padding:14px 18px;margin-bottom:18px;
  }
  .snav-promo-icon{font-size:28px;}
  .snav-promo-text{flex:1;}
  .snav-promo-title{font-size:13px;font-weight:700;color:#fff;margin-bottom:2px;}
  .snav-promo-sub{font-size:11px;color:rgba(255,255,255,.55);font-weight:500;}
  .snav-promo-btn{
    font-family:'Quicksand',sans-serif;
    background:#ff5c35;color:#fff;border:none;
    padding:7px 14px;border-radius:9px;
    font-size:12px;font-weight:700;cursor:pointer;
    white-space:nowrap;transition:opacity .15s;
  }
  .snav-promo-btn:hover{opacity:.88;}

  @media(max-width:960px){
    .snav-links{display:none;}
    .snav-search-desktop{display:none;}
    .snav-cta{display:none;}
    .snav-ham{display:flex;}
  }
  @media(max-width:480px){
    .snav-inner{padding:0 14px;height:60px;}
    .snav-mob{top:60px;}
    .snav-logo{font-size:20px;}
    .snav-mob-cat-grid{grid-template-columns:repeat(2,1fr);}
  }
`;


const menu = {
//  browse: {
   // label: "Browse",
   // featured: { label: "Trending Now", tag: "🔥", items: ["New Arrivals", "Under €30", "Sale Items", "Staff Picks", "Sustainable"] },
    sections: [
      {
        title: "",
        cats: [
          { icon: "", name: "Baseball Caps",    count: "", bg: "#fff1ee" },
          { icon: "", name: "Bags",   count: "", bg: "#eff6ff" },
           { icon: "", name: "Belts",   count: "", bg: "#eff6ff" },
          { icon: "", name: "Caps",   count: "",  bg: "#fffbeb" },
          { icon: "", name: "Hats",  count: "",  bg: "#f5f3ff" },
           { icon: "", name: "Reflector Jackets",   count: "",  bg: "#fffbeb" },
            { icon: "", name: "Towels",   count: "",  bg: "#fffbeb" },
            { icon: "", name: "Christmas Decoration",  count: "",  bg: "#f5f3ff" },
        ],
      },
      
    ],
  //},

 
};


const IconArrow = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);
  

  useEffect(() => {
    injectFont();
    if (!document.getElementById("snav-css")) {
      const s = document.createElement("style");
      s.id = "snav-css";
      s.textContent = CSS;
      document.head.appendChild(s);
    }
  }, []);

  
  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActive(null);
        setMobOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

 
  const allFlatCats = Object.values(MENUS)
    .flatMap((m) => m.sections.flatMap((s) => s.cats))
    .filter((c, i, arr) => arr.findIndex((x) => x.name === c.name) === i)
    .slice(0, 12);

 
  const navItems = [
    { name: 'Home', icon: <Home size={22} />, key: 'home', path: '/home' },
    { name: 'Categories', icon: <Grid3X3 size={22} />, key: 'categories', path: '/categories' }, // Opens modal
    { name: 'Shop', icon: <ShoppingBag size={22} />, key: 'shop', path: '/shop' }, // Opens modal
    { name: 'Wishlist', icon: <Heart size={22} />, key: 'savings', path: '/Wishlist' },
    { name: 'Account', icon: <Users  size={22} />, key: 'menu', path: '/myAccount' }, // Opens full premium menu
  ];

  
  const premiumMenuItems = [
    // Main Menu
    { label: 'Dashboard', path: '/dashboard', icon: <Home size={24} />, color: 'bg-blue-600' },

    { label: 'SMS Communication', path: '/SMS', icon: <BookOpen size={24} />, color: 'bg-teal-500' },

    { label: 'Add New Member (Sacco A)', path: '/NewMember/Sacco-A', icon: <Users size={24} />, color: 'bg-green-500' },
    { label: 'Sacco A - Active', path: '/Members/Sacco-A/Details', icon: <Users size={24} />, color: 'bg-emerald-600' },
    { label: 'Sacco A In-active', path: '/InactiveMembers/Sacco-A/Details', icon: <Users size={24} />, color: 'bg-red-500' },

   
    { label: 'Add New Member (Sacco B)', path: '/NewMember/Sacco-B', icon: <Users size={24} />, color: 'bg-green-500' },
    { label: 'Sacco B - Active', path: '/Members/Sacco-B/Details', icon: <Users size={24} />, color: 'bg-emerald-600' },
    { label: 'Sacco B In-active', path: '/InactiveMembers/Sacco-B/Details', icon: <Users size={24} />, color: 'bg-red-500' },

   
    { label: 'Members Savings', path: '/Members/Sacco-All/Savings', icon: <PiggyBank size={24} />, color: 'bg-emerald-500' },
    { label: 'Loan Requests', path: '/loanRequests/All', icon: <Files size={24} />, color: 'bg-orange-500' },
    { label: 'Loan Payments', path: '/Members/Sacco-All/LoanPayments', icon: <CreditCard size={24} />, color: 'bg-purple-500' },
    { label: 'Members Shares', path: '/Members/Sacco-All/Shares', icon: <Combine size={24} />, color: 'bg-indigo-500' },
    { label: 'Members Welfare', path: '/Members/Sacco-All/Welfare', icon: <Group size={24} />, color: 'bg-pink-500' },
    { label: 'Office Income', path: '/Members/Sacco-All/OfficeIncome', icon: <FileUp size={24} />, color: 'bg-yellow-500' },
    { label: 'Sacco Expenses', path: '/Expenses', icon: <Sheet size={24} />, color: 'bg-red-500' },
    { label: 'Member Vehicles', path: '/Vehicles', icon: <Truck size={24} />, color: 'bg-cyan-500' },
    { label: 'Insurance Payment', path: '/Insurance', icon: <WalletCards size={24} />, color: 'bg-violet-500' },
    { label: 'Sacco Sales', path: '/Sales', icon: <BadgePercent size={24} />, color: 'bg-teal-500' },

   
    { label: 'Daily Reports', path: '/daily-reports', icon: <HandCoins size={24} />, color: 'bg-amber-500' },
    { label: 'Loan Form Sales', path: '/Revenue-Filter/LoanForm', icon: <CalendarCheck size={24} />, color: 'bg-blue-500' },
    { label: 'Loan Interests', path: '/Revenue-Filter/LoanInterests', icon: <CalendarCheck size={24} />, color: 'bg-purple-600' },
    { label: 'Registration Revenue', path: '/Revenue-Filter/RegistrationRevenue', icon: <CalendarCheck size={24} />, color: 'bg-green-600' },
    { label: 'Sales Revenue', path: '/Revenue-Filter/SalesRevenue', icon: <CalendarCheck size={24} />, color: 'bg-teal-600' },
    { label: 'Defaulters Revenue', path: '/Revenue-Filter/DefaultersRevenue', icon: <CalendarCheck size={24} />, color: 'bg-red-600' },

   
    { label: 'Chart Of Accounts', path: '/chart-of-accounts', icon: <BarChart size={24} />, color: 'bg-lime-500' },
    { label: 'Trial Balances', path: '/trial-balance', icon: <ArrowRightLeft size={24} />, color: 'bg-sky-500' },
  ];

  const handleNavClick = (item) => {
    if (item.key === 'menu' || item.key === 'members') {
    
       navigate(item.path);
    }else if (item.key === 'Shop' || item.key === 'shop') {
         navigate(item.path+'/all');
    }else if (item.key === 'Categories' || item.key === 'categories') {
        
          setActive(!active);
      //setActiveTab(item.key);
    }else {
      navigate(item.path);
      setActive(!active);
      //setActiveTab(item.key);
    }
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setShowModal(false);
  };


  const Dropdown = ({ menu, open }) => (
  <div className={`snav-dropdown${open ? " open" : ""} fixed top-0 h-[100vh] bottom-16 left-0 right-0 z-[9999999]`}>
    
    {/* Header */}
    <div className="snav-drop-head">
      <span className="snav-drop-title">All {menu.label} Categories</span>
      <button   onClick={(e) =>{ e.preventDefault(); navigate('/Shop/all')}} className="snav-drop-viewall">
        View all <IconArrow />
      </button>
       <button onClick={(e)=>setActive(null)} className="snav-promo-btn">Close</button>
    </div>

    {/* Category sections */}
    <div className="snav-drop-body">
      {menu.sections.map((sec) => (
        <div className="snav-section" key={sec.title}>
          <div className="snav-section-label">{sec.title}</div>
          <div className="snav-cat-grid">
            {sec.cats.map((cat) => (
              <a
                key={cat.name}
                className="snav-cat-card cursor-pointer"
                
                onClick={(e) =>{ e.preventDefault(); navigate('/Shop/'+cat?.name?.toLowerCase()); setActive(null);}}
              >
                
                <div className="snav-cat-name">{cat.name}</div>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>

  
  </div>
);

  return (
    <>
    {active && (
    <>
    <Dropdown menu={menu} open={active}/>
    </>
    )}
      <div className="fixed bottom-0 md:hidden left-0 right-0 z-50 bg-white ">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => (
            <button
              key={item.key}
              onClick={() => handleNavClick(item)}
              className={`flex flex-col items-center text-xs font-medium transition-all duration-200 ${
                activeTab === item.key
                  ? 'text-orange-600 scale-110'
                  : 'text-gray-900 hover:text-blue-500'
              }`}
            >
              {item.icon}
              <span className="mt-1">{item.name}</span>
            </button>
          ))}
        </div>
      </div>

    
      {showModal && (
        <div className="fixed inset-0 z-[60] bg-white overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-blue-50">
            <h2 className="text-xl font-bold text-gray-900">All Features</h2>
            <button
              onClick={() => setShowModal(false)}
              className="p-2 rounded-full hover:bg-gray-200 transition-colors"
            >
              <X size={28} className="text-gray-700" />
            </button>
          </div>

          {/* Menu Items Grid */}
          <div className="p-5 overflow-y-auto" style={{ height: 'calc(100vh - 80px)' }}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {premiumMenuItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => handleMenuItemClick(item.path)}
                  className="group relative overflow-hidden rounded-2xl bg-white border border-gray-200 p-5 text-left transition-all duration-300 hover:shadow-xl hover:scale-[1.03] active:scale-95"
                >
                  {/* Icon Background */}
                  <div className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl ${item.color} text-white mb-4 shadow-md group-hover:scale-110 transition-transform duration-300`}>
                    {item.icon}
                  </div>
                  
                  {/* Label */}
                  <h3 className="font-semibold text-gray-900 text-sm leading-tight group-hover:text-blue-600 transition-colors">
                    {item.label}
                  </h3>
                  
                  {/* Subtle hover overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl pointer-events-none" />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}